import { hasTemplate, PublishedStatus } from './positions'

/**
 * Formats position data for analytics purposes.
 *
 * @param {Object} options
 * @param {string} options.source
 * @param {string} options.action
 * @param {string} [options.mechanism]
 * @param {Object} options.position
 * @param {boolean} options.hasJobSpec
 * @param {Object} options.hiringTeam
 *
 * @returns {Object} Formatted position analytics data.
 */
export const formatPositionAnalytics = ({ source, action, mechanism, position, hasJobSpec, hiringTeam }) => {
  const positionRoleRequirement = position.requirement
  return {
    source,
    action,
    mechanism,
    positionName: position.name,
    positionId: position.id,
    companyId: position.company_profile.id,
    hiringTeamId: hiringTeam.id,
    hiringTeamRegion: hiringTeam.region.code,
    hiringTeamCurrency: hiringTeam.currencyCode,
    hiringTeamRemunerationPeriod: hiringTeam.remunerationPeriod,
    hasJobSpec,
    hasDescription: !!position.description,
    hasTemplate: hasTemplate(position.message_template),
    published: position.published_status === PublishedStatus.Published.toLowerCase(),
    openings: position.openings,
    mainRole: positionRoleRequirement.primary_role_experience?.name,
    mainRoleExperience: positionRoleRequirement.primary_role_experience?.years_experience,
    otherRoles: positionRoleRequirement.other_roles?.map(role => role.name),
    mustSkills: positionRoleRequirement.must_have_skill_experiences?.map(skill => skill.name),
    niceSkills: positionRoleRequirement.nice_to_have_skills?.map(skill => skill.name),
    citizenshipCountries: positionRoleRequirement.work_authorisation?.citizenship_countries_iso2,
    citizenshipStatuses: positionRoleRequirement.work_authorisation?.citizenship_statuses,
    visaSponsorship: positionRoleRequirement.visa_sponsorship_available,
    workplacePolicy: positionRoleRequirement.workplace_policy?.type,
    preferredLocations: positionRoleRequirement.workplace_policy?.comprehensive_locations.map(comp => comp.inputted_address),
    otherLocations: positionRoleRequirement.other_comprehensive_locations?.map(comp => comp.inputted_address),
    employmentType: positionRoleRequirement.employment_type,
    contractDuration: positionRoleRequirement.contract_duration_months,
    minBudget: positionRoleRequirement.salary_min,
    maxBudget: positionRoleRequirement.salary_max,
    language: positionRoleRequirement.language_iso639_1_codes,
  }
}
